/**
 * Module for configuring the KB contexts as part of the KB creation wizard
 */
define([
  "backbone",
  "underscore",
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/accountAdmin/kbWizardModal/kbContexts/kbContextsView",
  "modules/shared/sortableList/sortableListModule",
  "modules/accountAdmin/kbAdmin/kbModel",
], function (
  Backbone,
  _,
  Marionette,
  $,
  Messenger,
  kbContextsView,
  SortableListModule,
  // eslint-disable-next-line no-unused-vars
  KbModel,
) {
  "use strict";

  var KbContextsModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "kbContexts";
      this.region = options.region;
      this.editMode = options.editMode;
      this._setUpVents();
    },

    show: function (kb) {
      this.kb = kb;

      this.layout = new kbContextsView.kbContextsLayout({
        model: this.kb,
      });

      this.contexts = this.kb.getContexts();
      var headers = Messenger.reqres.request("kb:context:list:headers");

      var extendedEvents = {
        "click .deleteKbContext": function () {
          this.model.deleteModel();
          Messenger.vent.trigger("clear:context:errors");
        },
      };

      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.list,
          headers: headers,
          namespace: this.name,
          extendedEvents: extendedEvents,
          hideHeader: true,
          hideControls: true,
        }),
      );

      this.layout.on(
        "show",
        function () {
          this.list.show(this.contexts);
        },
        this,
      );

      this.contexts.onSynced(function () {
        //If this is a new KB, add a 'All Interfaces' default context
        if (!this.editMode && this.contexts.length === 0) {
          this.addContext("All Interfaces");
        }
        this.showRegion(this.layout);
      }, this);

      this.layout.on(
        "addContext",
        function () {
          this.addContext(this.layout.getContext());
        },
        this,
      );
    },
    addContext: function (contextName) {
      var _this = this;
      var newContext = this.contexts.addItem();
      newContext.set("status", contextName);
      newContext.on(
        "invalid",
        function (model, error) {
          this.layout.clearErrors();
          if (error["status"]) {
            this.layout.contextError(error["status"]);
            newContext.deleteModel();
          }
        },
        this,
      );
      if (this.editMode) {
        newContext.saveModel({
          success: function () {
            _this.layout.clearErrors();
            _this.layout.clearContext();
          },
          error: function (model, response) {
            if (response.status === 400) {
              Messenger.okDialog(
                $.t("admin.kbAdmin.addContextError", { message: response.responseJSON.value }),
              );
            } else {
              Messenger.showErrorFromResponse(response);
            }
          },
        });
      } else {
        if (newContext.isValid()) {
          _this.layout.clearErrors();
          _this.layout.clearContext();
        }
      }
    },
    getKb: function () {
      return this.kb;
    },
    isValid: function () {
      if (this.contexts.length === 0) {
        this.layout.clearErrors();
        this.layout.contextError($.t("admin.kbAdmin.emptyContextListError"));
        return false;
      } else {
        return true;
      }
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "clear:context:errors",
        function () {
          this.layout.clearErrors();
        },
        this,
      );
    },
  });

  return KbContextsModule;
});
